import { render } from "./VideoCut.vue?vue&type=template&id=5204454c&scoped=true"
import script from "./VideoCut.vue?vue&type=script&lang=js"
export * from "./VideoCut.vue?vue&type=script&lang=js"

import "./VideoCut.vue?vue&type=style&index=0&id=5204454c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5204454c"]])

export default __exports__